import React from "react";
import { Card, CardHeader, Input, Container, Button, Table, Row } from "reactstrap";
import { useState } from "react"
import { failureToast, successToast } from '../../common/utils/methods/toasterFunctions/function'
import { TDROW, MasterHeader } from "../../common/commonComponents/masterRow/masterRow";
import { masterServiceBaseUrl, putpost, putpost2 } from 'services/http'
import moment from 'moment';
import CreateButton from "components/FormComponent/Button/New/index";
import UpdateButton from "components/FormComponent/Button/Update/index";
import { ButtonText } from "variables/Buttons";
import CustomButton from 'components/CustomButton';

var _ = require('lodash');

const SessionTable = (props) => {
	const { userPermissions, isSaveVisible, setisSaveVisible = () => { } } = props;
	const [tableDataKey, settableDataKey] = useState('tableDataKey');
	const addNewClass = () => {
		props.setclassArray([
			{
				editMode: true,
				__status: '__new',
				sessionKey: null,
				status: 'ACTIVE',
				sessionDesc: null,
				sessionDispValue: null,
				effectiveDate: null,
			},
			...props.classArray,
		]);
	};
	const saveAll = (cb) => {
		var _tempArray = props.classArray;
		var isValid = true;
		_tempArray.forEach((el, index) => {
			if (el['editMode']) {
				if (el['sessionKey'] === null || !el['sessionKey'].trim()) {
					isValid = false;
					failureToast('Please enter the value of Session Key');
					return;
				} else if (el['sessionDesc'] === null || !el['sessionDesc'].trim()) {
					isValid = false;
					failureToast('Please enter the value of Description');
					return;
				} else if (
					el['sessionDispValue'] === null ||
					!el['sessionDispValue'].trim()
				) {
					isValid = false;
					failureToast('Please enter the value of Display Value');
					return;
				}
				if (!isValid) {
					return;
				}
				if (_tempArray[index]['__status'] == '__new') {
					putpost(
						masterServiceBaseUrl + '/session/createSession',
						(data) => {
							successToast(data['message']);
							setisSaveVisible(false);
							props.fetchClasses(
								masterServiceBaseUrl + '/session/getAllSession'
							);
						},
						(data) => {
							failureToast(data['message']);
						},
						_tempArray[index],
						'post'
					);
				} else {
					putpost(
						masterServiceBaseUrl +
						'/session/updateSession/' +
						_tempArray[index].id,
						(data) => {
							successToast(data['message']);
							setisSaveVisible(false);
							delete _tempArray[index]['editMode'];
							props.setclassArray(_tempArray);
							settableDataKey(new Date().getMilliseconds());
							// props.fetchClasses(masterServiceBaseUrl + '/class/getAllClass')
						},
						(data) => {
							failureToast(data['message']);
						},
						_tempArray[index],
						'put'
					);
				}
			} else {
			}
		});
	};
	const newRow = () => {
		if (isSaveVisible) {
			failureToast('Please Delete or Save current changes');
		} else {
			let cb = () => {
				addNewClass();
				setisSaveVisible(true);
				// settableDataKey(new Date().getMilliseconds())
			};
			var _tempArray = props.classArray;
			_tempArray = _.sortBy(_tempArray, [
				function (o) {
					return o.value;
				},
			]);
			props.setclassArray(_tempArray);
			setisSaveVisible(false);
			cb();
		}
	};
	const editRow = (index) => {
		if (isSaveVisible) {
			failureToast('Please Delete or Save current changes');
		} else {
			let cb = () => {
				var _tempArray = props.classArray;
				_tempArray[index]['editMode'] = true;
				props.setclassArray(_tempArray);
				setisSaveVisible(true);
			};
			var _tempArray = props.classArray;
			_tempArray = _.sortBy(_tempArray, [
				function (o) {
					return o.value;
				},
			]);
			cb();
		}
	};
	const deleteRow = (index) => {
		if (props.classArray[index]['__status'] == '__new') {
			let n = props.classArray;
			n.splice(index, 1);
			props.setclassArray(n);
			setisSaveVisible(false);
			settableDataKey(new Date().getMilliseconds());
		} else {
			if (window.confirm('Are you sure you want to delete this Session?')) {
				putpost2(
					masterServiceBaseUrl +
					'/session/deleteSession/' +
					props.classArray[index].id,
					(data) => {
						successToast(data['message']);
						// var _tempArray = props.classArray
						// if (_tempArray[index]['editMode']) {
						//   setisSaveVisible(false)
						// }
						// _tempArray.splice(index, 1)
						// props.setclassArray(_tempArray)
						if (props.classArray.length == 1) {
							props.previousPage();
						}
						props.fetchClasses(masterServiceBaseUrl + '/session/getAllSession');
						settableDataKey(new Date().getMilliseconds());
					},
					(data) => {
						failureToast(data['message']);
					},
					'DELETE'
				);
			}
		}
	};
	const updateKey = (index, value, key) => {
		var _tempArray = props.classArray;
		_tempArray[index][key] = value;
		props.setclassArray(_tempArray);
	};
	return (
		<>
			<Container className="mt-3" fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader className="border-0">
								<h3 className="mb-0 floatLeft">Master - Session </h3>
								<CustomButton
									disabled={isSaveVisible}
									className={
										'floatRight mx-1' +
										(isSaveVisible ? ' btn-dark cursor-gray' : null)
									}
									content={'New Session'}
									permissionType={'C'}
									icon={true}
									permissionSet={userPermissions}
									onClick={() => {
										newRow();
									}}
								/>
							</CardHeader>
							<div id="questionTable" className="table-responsive Control-bar">
								<Table className="align-items-center table-flush tableLayout">
									<MasterHeader
										type={'Session'}
										isSaveVisible={isSaveVisible}
										permissionSet={userPermissions}
									/>
									<tbody className="list" key={tableDataKey}>
										{props.classArray
											? props.classArray.map((el, index) =>
												!el['editMode'] ? (
													<TDROW
														type={'session'}
														index={index}
														el={el}
														editRow={editRow}
														deleteRow={deleteRow}
														key={index}
														isSaveVisible={isSaveVisible}
														permissionSet={userPermissions}
													/>
												) : (
													<tr key={index + '-class'}>
														<td className="text-center p-2 mx-1">
															<Input
																maxLength="50"
																defaultValue={el['sessionKey']}
																onChange={(e) => {
																	updateKey(
																		index,
																		e.target.value,
																		'sessionKey'
																	);
																}}
																placeholder="Example:1"
																className="tdInput"
																data-testid="sessionKey"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																disabled={true}
																defaultValue={
																	el['__status'] == '__new'
																		? null
																		: moment(el['effectiveDate']).format(
																			'DD-MM-YYYY'
																		)
																}
																placeholder="Example:01-01-2020"
																className="tdInput"
																data-testid="effectiveDate"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																maxLength="50"
																defaultValue={el['sessionDesc']}
																onChange={(e) => {
																	updateKey(
																		index,
																		e.target.value,
																		'sessionDesc'
																	);
																}}
																placeholder="Description"
																className="tdInput"
																data-testid="sessionDesc"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<Input
																maxLength="50"
																defaultValue={el['sessionDispValue']}
																onChange={(e) => {
																	updateKey(
																		index,
																		e.target.value,
																		'sessionDispValue'
																	);
																}}
																placeholder="Display Value"
																className="tdInput"
																data-testid="sessionDispValue"
															/>
														</td>
														<td className="text-center p-2 mx-1">
															<label className="custom-toggle mx-auto ml-2">
																<input
																	checked={
																		el.status == 'ACTIVE' ? true : false
																	}
																	type="checkbox"
																	id={el.id}
																	onChange={(e) => {
																		settableDataKey(
																			new Date().getMilliseconds()
																		);
																		let n = 'ACTIVE';
																		if (!e.target.checked) {
																			n = 'INACTIVE';
																		}
																		updateKey(index, n, 'status');
																	}}
																	data-testid="status"
																/>
																<span
																	style={{ width: '72px' }}
																	className="custom-toggle-slider rounded-circle activeToggle"
																	data-label-off="Inactive"
																	data-label-on="Active"
																/>
															</label>
														</td>
														<td className="text-center">
															{isSaveVisible ? (
																<>
																	<CustomButton
																		content={'Save'}
																		permissionType={'C,U'}
																		forTable={true}
																		permissionSet={userPermissions}
																		onClick={() => {
																			saveAll();
																		}}
																	/>
																	<CustomButton
																		permissionType={'cancel'}
																		icon={true}
																		forTable={true}
																		permissionSet={userPermissions}
																		onClick={() => {
																			let n = props.classArray;
																			if (n[index]['__status'] == '__new') {
																				n.splice(index, 1);
																			} else {
																				// n[index]['editMode']=false
																				props.fetchClasses(
																					masterServiceBaseUrl +
																					'/session/getAllSession'
																				);
																			}
																			props.setclassArray(n);
																			setisSaveVisible(false);
																		}}
																	/>
																</>
															) : (
																<CustomButton
																	permissionType={'D'}
																	icon={true}
																	forTable={true}
																	onClick={() => deleteRow(index)}
																	permissionSet={userPermissions}
																/>
															)}
														</td>
													</tr>
												)
											)
											: null}
									</tbody>
								</Table>
							</div>
						</Card>
					</div>
				</Row>
			</Container>
		</>
	);
};
export default SessionTable;